import i18n from "@/i18n";

const normalize = (value) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const rawTranslationMap = {
  id: "tabelasfront.id",
  idviagem: "tabelasfront.tripId",
  data: "tabelasfront.date",
  linha: "tabelasfront.line",
  guia: "tabelasfront.guide",
  veiculo: "tabelasfront.vehicle",
  "veiculo previsto": "tabelasfront.expectedVehicle",
  "veiculo realizado": "tabelasfront.realizedVehicle",
  "saida prevista": "tabelasfront.predictedDeparture",
  "saida realizada": "tabelasfront.realizedDeparture",
  "horario saida realizado": "tabelasfront.departureTimeRealized",
  "horario chegada realizado": "tabelasfront.arrivalTimeRealized",
  "chegada prevista": "tabelasfront.predictedArrival",
  "chegada realizada": "tabelasfront.realizedArrival",
  "tempo previsto": "tabelasfront.predictedTime",
  "tempo realizado": "tabelasfront.realizedTime",
  "tempo viagem previsto": "tabelasfront.predictedTravelTime",
  "tempo viagem realizado": "tabelasfront.realizedTravelTime",
  sentido: "tabelasfront.direction",
  turno: "tabelasfront.shift",
  motorista: "tabelasfront.driver",
  cobrador: "tabelasfront.collector",
  "matricula motorista": "tabelasfront.driverRegistration",
  "matricula cobrador": "tabelasfront.collectorRegistration",
  temperatura: "tabelasfront.temperature",
  clima: "tabelasfront.weather",
  status: "tabelasfront.status",
  conciliada: "tabelasfront.conciliated",
  km: "tabelasfront.km",
  "km aferido": "tabelasfront.measuredKm",
  "km nominal": "tabelasfront.nominalKm",
  "km operadora": "tabelasfront.operatorKm",
  "km merus - operadora": "tabelasfront.diffMerusOperatorKm",
  diesel: "tabelasfront.diesel",
  "diesel / km": "tabelasfront.dieselPerKm",
  "km / diesel": "tabelasfront.kmPerDiesel",
  ipk: "tabelasfront.ipk",
  "atraso saida": "tabelasfront.departureDelay",
  "escalonamento veiculo": "tabelasfront.vehicleScheduling",
  "saida esc. previsto": "tabelasfront.scheduledDeparture",
  "atraso escalonamento": "tabelasfront.schedulingDelay",
  "escalonamento viagem": "tabelasfront.tripScheduling",
  "atraso chegada": "tabelasfront.arrivalDelay",
  "cerca inicio": "tabelasfront.startFence",
  "cerca fim": "tabelasfront.endFence",
  sistema: "vehicleAuthorization.headers.system",
  codigo: "vehicleAuthorization.headers.code",
  autorizado: "vehicleAuthorization.headers.authorized",
  tipo: "vehicleAuthorization.headers.type",
  tarifa: "vehicleAuthorization.headers.fare",
  acoes: "vehicleAuthorization.headers.actions",
};

const translationMap = Object.keys(rawTranslationMap).reduce((acc, key) => {
  acc[normalize(key)] = rawTranslationMap[key];
  return acc;
}, {});

const getTranslatedValue = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  const normalized = normalize(value);
  const translationKey = translationMap[normalized];

  if (translationKey) {
    return i18n.t(translationKey);
  }

  return value;
};

export default function TranslateHeader(header) {
  if (!header) {
    return "";
  }

  if (typeof header === "string") {
    return getTranslatedValue(header);
  }

  if (header && typeof header === "object") {
    return getTranslatedValue(header.text);
  }

  return "";
}